import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { getPlanSaveLabel } from '../../shared/plan-helpers';
import styles from './SubscriptionCardV12.css';

const cx = classnames.bind(styles);
const DEFAULT_BILLING_PERIOD_VALUE = 4;

function getPeriodLabel({ billingPeriod }) {
    const value = billingPeriod?.value || DEFAULT_BILLING_PERIOD_VALUE;
    const unit = billingPeriod?.unit || 'week';

    return `${value} ${unit}${value > 1 ? 's' : ''}`;
}

function SubscriptionCardV12({ subscriptionData, selectedSubscriptionData, selectSubscription, isExpired = false, name = 'subscription-plan', hasBoldPrices = false }) {
    const isActive = subscriptionData.plan === selectedSubscriptionData.plan;
    const oldPrice = subscriptionData.displayOldPrice ?? subscriptionData.price;
    const newPrice = subscriptionData.trial?.price ?? subscriptionData.price;
    const hasOldPrice = !isExpired && oldPrice !== newPrice;
    const saveLabel = hasOldPrice && !subscriptionData.isDiscountBadgeHidden ? getPlanSaveLabel(subscriptionData) : null;
    const period = getPeriodLabel(subscriptionData);
    const Price = hasBoldPrices ? 'b' : 'span';

    return (
        <label className={cx('root', { active: isActive, popular: Boolean(subscriptionData.isPopular) })}>
            <input
                type='radio'
                name={name}
                value={subscriptionData.plan}
                checked={isActive}
                onChange={() => selectSubscription(subscriptionData)}
                className={styles.input}
            />
            {Boolean(subscriptionData.isPopular) && (
                <span className={styles.badge}>
                    <Icon name='starFilled' className={styles.star} />
                    best offer
                </span>
            )}
            <span className={styles.content}>
                <span className={styles.radio} />
                <span className={styles.info}>
                    <span className={styles.name}>{subscriptionData.name}</span>
                    <span className={styles.description}>
                        {subscriptionData.trial
                            ? <><Price>{newPrice}</Price>{' now, then '}<Price>{subscriptionData.price}</Price>{` every ${period}`}</>
                            : <><Price>{subscriptionData.price}</Price>{` every ${period}`}</>
                        }
                    </span>
                </span>
                <span className={styles.prices}>
                    {hasOldPrice && <s className={styles.oldPrice}>{oldPrice}</s>}
                    <span className={styles.newPrice}>{newPrice}</span>
                    {Boolean(saveLabel) && <span className={styles.save}>{`SAVE ${saveLabel}`}</span>}
                </span>
            </span>
        </label>
    );
}

SubscriptionCardV12.propTypes = {
    subscriptionData: PropTypes.object.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isExpired: PropTypes.bool,
    name: PropTypes.string,
    hasBoldPrices: PropTypes.bool
};

export {
    SubscriptionCardV12
};
